// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sanomatSans_6c495c', '__sanomatSans_Fallback_6c495c'"},"className":"__className_6c495c","variable":"__variable_6c495c"};